import React, {useState} from 'react';
import './ActivityLog.scss';
import * as _ from 'lodash';
import ActivityLogItem from "./ActivityLogItem";
import ActivityLogModal from "./ActivityLogModal";
import Paper from "@material-ui/core/Paper";


function ActivityLog(props) {
  let [openActivityLogModal, setActivityLogModal] = useState(false);

  const toggleModal = () => setActivityLogModal(!openActivityLogModal);

  return (
    <Paper className="activity-log-card">
      <div className="text-left dashboard-sidebar-title">
        <span className="font-bold uppercase-text">Activity Log</span>
      </div>
      <div className="relative activity-log-container">
        {
          props.activityLog.length ?
            <div>
              <div>
                {
                  _.map(_.take(props.activityLog, 5), (activity,i) => <ActivityLogItem key={i} activity={activity}/>)
                }
              </div>
              {
                props.activityLog.length > 5 &&
                <div className="flex items-center other-notifications-container between-xs text-sm">
                  <p className="text-grey">{props.activityLog.length - 5} HIDDEN</p>
                  <a className="text-secondary" onClick={toggleModal}>View all</a>
                </div>
              }
            </div>
            :
            <div className="flex items-center center-xs no-activity">
              <span className="text-grey">No Events Found.</span>
            </div>
        }

      </div>
      <ActivityLogModal open={openActivityLogModal} activityLog={props.activityLog} onClose={toggleModal}/>
    </Paper>
  );
};

export default ActivityLog;
